/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';

const BlueArrowRight = () => {

    return (
        <div className="blueArrowRight">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 87.6 56.8" enableBackground="new 0 0 87.6 56.8" xmlSpace="preserve">
                <line className="blueArrowRight__body" fill="none" stroke="#6F93B8" strokeWidth="5" strokeLinecap="round" strokeMiterlimit="10" x1="3.5" y1="28.5" x2="77.1" y2="28.5"/>

                <polyline className="blueArrowRight__head" fill="none" stroke="#6F93B8" strokeLinecap="round" strokeMiterlimit="2" points="58,53.5 82.6,28.2 58,3.4"/>
            </svg>
        </div>
    );
}

export default BlueArrowRight;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/BlueArrowRight.jsx